<template>
  <v-file-input v-model="files" small-chips multiple :label="$t('Select_file')" @change="$emit('input', files)" />
</template>

<script>
export default {
  name: 'MultipleFileInput',
  data() {
    return {
      files: [],
    }
  },
  methods: {
    cleanup() {
      this.files = []
    },
  },
}
</script>
